import React from 'react';
import LocalStorageService from '../Services/LocalStorageService';

export type LocalStorageContextProps = {
    localStorageService: LocalStorageService,
};

const LocalStorageContext: React.Context<LocalStorageContextProps> = React.createContext<LocalStorageContextProps>({
    localStorageService: new LocalStorageService('purchase'),
});

export default LocalStorageContext;